import React from 'react';
import { motion } from 'framer-motion';
import { CalendarX } from 'lucide-react';
import type { VenueEvent } from '../data/events';
interface EventsGridViewProps {
  events: VenueEvent[];
}
export function EventsGridView({
  events
}: EventsGridViewProps) {
  if (events.length === 0) {
    return <EmptyState data-id="element-283" />;
  }
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-284">
      {events.map((event, index) => <motion.div key={event.id} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: index * 0.05,
      duration: 0.4
    }} className="group relative bg-[#0B1014] border border-white/10 hover:border-[#DDA247] transition-all duration-300 overflow-hidden cursor-pointer" data-id="element-285">
          {/* Image */}
          <div className="relative h-80 overflow-hidden" data-id="element-286">
            <img src={event.image} alt={event.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-287" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" data-id="element-288" />

            {/* Category tag */}
            <span className="absolute top-3 right-3 bg-[#0B1014]/80 backdrop-blur-sm text-[#DDA247] px-3 py-1 text-[10px] font-bold uppercase tracking-widest border border-[#DDA247]/30 rounded-full" data-id="element-289">
              {event.category}
            </span>

            {/* Content Overlay */}
            <div className="absolute inset-0 flex flex-col justify-end p-6 text-center" data-id="element-290">
              <div className="bg-[#DDA247] text-[#0B1014] px-3 py-1 text-xs font-bold uppercase tracking-wider mb-3 inline-block self-center" data-id="element-291">
                {event.type}, {event.date}
              </div>
              <h3 className="text-white font-bold text-xl mb-2 uppercase tracking-wide" data-id="element-292">
                {event.title}
              </h3>
              <p className="text-white text-2xl font-bold mb-2" data-id="element-293">
                {event.artist}
              </p>
              <p className="text-gray-400 text-sm tracking-wider" data-id="element-294">
                {event.time}
              </p>

              {/* Hover CTA */}
              <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileHover={{
            opacity: 1,
            y: 0
          }} className="mt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-295">
                <button className="bg-[#DDA247] text-[#0B1014] px-6 py-2 text-sm font-bold uppercase tracking-wider hover:bg-white transition-colors" data-id="element-296">
                  Buy Tickets
                </button>
              </motion.div>
            </div>
          </div>
        </motion.div>)}
    </div>;
}
function EmptyState() {
  return <div className="flex flex-col items-center justify-center text-center py-24 bg-[#11161A] border border-white/10 rounded-2xl" data-id="element-297">
      <div className="inline-flex items-center justify-center w-16 h-16 mb-5 bg-[#DDA247]/10 rounded-full" data-id="element-298">
        <CalendarX className="w-8 h-8 text-[#DDA247]" data-id="element-299" />
      </div>
      <h3 className="text-xl font-bold text-white mb-2 tracking-wide" data-id="element-300">
        No Events Found
      </h3>
      <p className="text-gray-400 text-sm max-w-sm" data-id="element-301">
        Try adjusting your filters or clearing them to see all upcoming events.
      </p>
    </div>;
}